import { User } from './User';

import {
  listCompanyUsers,
  listProxiesByPoll,
} from '@sdk/managers/UsersManager';
import { CompanyRole } from '@sdk/API';

export interface Proxy {
  id: string;
  companyID: string;
  userID: string;
  user: User;
}

export async function getProxies(
  _query: string,
  userId: string
): Promise<Proxy[]> {
  console.log('listCompanyUsers', userId, CompanyRole.PROXY);
  const res: any = await listCompanyUsers(userId, CompanyRole.PROXY);
  console.log(res);
  return res?.data?.result?.items;
}

export async function getPollProxies(
  _query: string,
  pollId: string
): Promise<Proxy[]> {
  console.log('listProxiesByPoll', pollId);
  const res: any = await listProxiesByPoll(pollId, ['id']);
  return res?.data?.result?.items;
}

export interface ProxyVote {
  id: string;
  pollID: string;
  userID: string;
  user: {
    email: string;
    firstName: string;
  };
  option: {
    description: string | null;
    id: string;
    title: string | null;
  };
}
